// FAQ della homepage — testo condiviso tra l'accordion visibile (HomeMain)
// e lo schema FAQPage (JSON-LD in App.js), così restano identici.
// Ogni risposta ha un link interno pertinente (to + linkLabel).
const HOME_FAQ = [
  {
    q: "Cos'è Vita da Host e a chi si rivolge?",
    a: "Vita da Host è il portale italiano per chi gestisce B&B, case vacanza, affittacamere, agriturismi, glamping e locazioni turistiche. Ogni giorno pubblica notizie e guide su normative, tasse e piattaforme, offre consulenze con professionisti, corsi in diretta e on demand e strumenti gratuiti. È nato a Genova nel 2023 da host che gestiscono strutture in prima persona.",
    to: "/servizi",
    linkLabel: "Scopri tutti i servizi",
  },
  {
    q: "Come si apre un B&B in Italia?",
    a: "Per aprire un B&B si presenta la SCIA al Comune o allo Sportello unico, si verificano i requisiti della propria regione (numero di camere, posti letto e, in molte regioni, la residenza del titolare), si richiede il CIN e si comunica l'attività a Questura e portale Alloggiati. Le regole cambiano da regione a regione: controlla sempre la normativa locale.",
    to: "/servizi/inizia-avventura",
    linkLabel: "Guida per aprire la tua struttura",
  },
  {
    q: "Come si apre una casa vacanza?",
    a: "La casa vacanza si apre di solito con una SCIA al Comune e seguendo il regolamento della tua regione, che stabilisce se la gestione può restare non imprenditoriale o richiede la partita IVA oltre una certa soglia di unità. Servono anche il CIN, la comunicazione dei prezzi dove prevista e la registrazione degli ospiti. Verifica le soglie regionali prima di partire.",
    to: "/servizi/inizia-avventura",
    linkLabel: "Vedi come iniziare",
  },
  {
    q: "Che differenza c'è tra B&B, affittacamere e casa vacanza?",
    a: "Il B&B è la gestione di poche camere nella propria abitazione, spesso con prima colazione e in forma non imprenditoriale. L'affittacamere offre camere con eventuali servizi ma in forma imprenditoriale, con partita IVA. La casa vacanza è un alloggio dato per intero agli ospiti. Ogni regione fissa limiti di camere, posti letto e servizi diversi.",
    to: "/servizi",
    linkLabel: "Approfondisci i servizi per host",
  },
  {
    q: "Cos'è il CIN e come si richiede?",
    a: "Il CIN, Codice Identificativo Nazionale, è il codice che identifica ogni struttura ricettiva e locazione turistica. Si richiede nella Banca Dati Strutture Ricettive del Ministero del Turismo accedendo con SPID o CIE. Una volta ottenuto va indicato in tutti gli annunci ed esposto all'esterno dell'immobile. Con il servizio CIN Facile puoi farti seguire nella pratica.",
    to: "/servizi/cin-facile",
    linkLabel: "Richiedi il CIN con CIN Facile",
  },
  {
    q: "Quante tasse si pagano sugli affitti brevi?",
    a: "Sulle locazioni brevi puoi scegliere la cedolare secca al 21% su un solo immobile; dal secondo al quarto immobile affittato in forma breve l'aliquota è del 26%. In alternativa c'è l'IRPEF ordinaria. Oltre quattro immobili serve la partita IVA. Alcune aliquote sono in discussione con la Manovra 2027: verifica gli aggiornamenti prima di decidere.",
    to: "/blog",
    linkLabel: "Leggi gli aggiornamenti fiscali sul blog",
  },
  {
    q: "Quando serve la partita IVA per gli affitti brevi?",
    a: "La partita IVA serve quando affitti in forma breve più di quattro immobili nello stesso anno, perché l'attività diventa imprenditoriale, oppure quando offri servizi aggiuntivi tipici dell'impresa come colazione, pulizie durante il soggiorno o reception. Con un massimo di quattro appartamenti e senza servizi accessori puoi restare nella gestione non imprenditoriale con cedolare secca.",
    to: "/consulenze",
    linkLabel: "Chiedi a un commercialista host",
  },
  {
    q: "Come si registrano gli ospiti su Alloggiati Web?",
    a: "Entro 24 ore dall'arrivo, o lo stesso giorno per i soggiorni di una notte, devi comunicare i dati dei documenti degli ospiti alla Questura tramite il portale Alloggiati Web della Polizia di Stato. Serve un account rilasciato dalla Questura competente. La verifica dell'identità va fatta di persona o con sistemi equivalenti riconosciuti.",
    to: "/blog",
    linkLabel: "Leggi la guida su check-in e identificazione",
  },
  {
    q: "Le consulenze gratuite sono davvero gratis?",
    a: "Sì. Le consulenze gratuite durano 15 minuti, si svolgono online su Google Meet e non richiedono alcun pagamento. Sono un primo confronto con un professionista per capire da dove partire. Se poi ti serve un supporto più approfondito puoi prenotare una consulenza dedicata a pagamento, con sconto per i soci HostClub.",
    to: "/consulenze",
    linkLabel: "Prenota una consulenza gratuita",
  },
  {
    q: "Cos'è HostClub e quanto costa?",
    a: "HostClub è la community premium di Vita da Host: costa 19,90 euro l'anno e dà diritto a consulenze scontate, file e modelli gratuiti, sconti dei partner, forum interno e chat diretta con il team. È pensata per host e property manager che vogliono strumenti concreti e aggiornamenti continui sulle normative.",
    to: "/hostclub",
    linkLabel: "Scopri HostClub",
  },
];

export default HOME_FAQ;
